(function () {
  var MONTH_FORMAT = new Intl.DateTimeFormat('de-DE', { month: 'long', year: 'numeric' });
  var MONTH_SHORT_FORMAT = new Intl.DateTimeFormat('de-DE', { month: 'short' });
  var WEEKDAY_FORMAT = new Intl.DateTimeFormat('de-DE', { weekday: 'short' });

  function makeDate(year, month, day) {
    var date = new Date(year, month - 1, day, 12, 0, 0, 0);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    return date;
  }

  function parseDateRange(rawTitle) {
    var parts = String(rawTitle || '').split('|');
    var datePart = (parts.shift() || '').trim();
    var timePart = parts.join('|').trim();
    var normalized = datePart.replace(/[–—]/g, '-').replace(/\s+/g, '');
    var match;
    var start;
    var end;

    match = normalized.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (match) {
      start = makeDate(Number(match[3]), Number(match[2]), Number(match[1]));
      end = start;
    }

    if (!start) {
      match = normalized.match(/^(\d{1,2})\.-(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      if (match) {
        start = makeDate(Number(match[4]), Number(match[3]), Number(match[1]));
        end = makeDate(Number(match[4]), Number(match[3]), Number(match[2]));
      }
    }

    if (!start) {
      match = normalized.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})-(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      if (match) {
        start = makeDate(Number(match[3]), Number(match[2]), Number(match[1]));
        end = makeDate(Number(match[6]), Number(match[5]), Number(match[4]));
      }
    }

    if (!start || !end) return null;

    return {
      start: start,
      end: end,
      time: timePart || 'Uhrzeit folgt'
    };
  }

  function formatDate(info) {
    var sameDay = info.start.getTime() === info.end.getTime();
    var sameMonth = info.start.getFullYear() === info.end.getFullYear() &&
      info.start.getMonth() === info.end.getMonth();
    var main;

    if (sameDay) {
      main = WEEKDAY_FORMAT.format(info.start) + ', ' + info.start.getDate() + '. ' + MONTH_SHORT_FORMAT.format(info.start);
    } else if (sameMonth) {
      main = info.start.getDate() + '.–' + info.end.getDate() + '. ' + MONTH_SHORT_FORMAT.format(info.start);
    } else {
      main = info.start.getDate() + '. ' + MONTH_SHORT_FORMAT.format(info.start) +
        ' – ' + info.end.getDate() + '. ' + MONTH_SHORT_FORMAT.format(info.end);
    }

    return {
      main: main,
      year: info.start.getFullYear() === info.end.getFullYear()
        ? String(info.start.getFullYear())
        : String(info.start.getFullYear()) + '–' + String(info.end.getFullYear()),
      month: MONTH_FORMAT.format(info.start).toUpperCase()
    };
  }

  function getProductInfo(root) {
    return root.closest('product-info');
  }

  function getSubmitButton(productInfo) {
    return productInfo ? productInfo.querySelector('.product-form__submit') : null;
  }

  function setSubmitState(productInfo, enabled, label) {
    var button = getSubmitButton(productInfo);
    if (!button) return;

    var text = button.querySelector('span');
    if (text && label) text.textContent = label;

    if (enabled) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    } else {
      button.disabled = true;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  function setVariant(productInfo, variantId) {
    if (!productInfo) return;
    var inputs = productInfo.querySelectorAll('input.product-variant-id, form.installment input[name="id"]');
    inputs.forEach(function (input) {
      input.disabled = false;
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateQuantity(productInfo, inventory) {
    if (!productInfo) return;
    var input = productInfo.querySelector('.quantity__input');
    if (!input) return;

    if (inventory > 0) {
      input.setAttribute('max', String(inventory));
      if (Number(input.value || 1) > inventory) input.value = '1';
    } else {
      input.removeAttribute('max');
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectSlot(root, slot) {
    if (!slot || slot.disabled) return;
    var productInfo = getProductInfo(root);
    var variantId = slot.getAttribute('data-variant-id');
    var inventory = Number(slot.getAttribute('data-inventory') || -1);

    root.querySelectorAll('[data-vp-slot]').forEach(function (item) {
      var selected = item === slot;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    setVariant(productInfo, variantId);
    updateQuantity(productInfo, inventory);
    setSubmitState(productInfo, true, 'Jetzt buchen');

    var hint = root.querySelector('[data-vp-hint]');
    if (hint) hint.hidden = false;

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function applyLimit(root, expanded) {
    var groups = Array.prototype.slice.call(root.querySelectorAll('.vp-academy-month'));
    var index = 0;

    groups.forEach(function (group) {
      var visibleInGroup = 0;
      group.querySelectorAll('[data-vp-slot]').forEach(function (slot) {
        var shouldShow = expanded || index < 4;
        slot.hidden = !shouldShow;
        if (shouldShow) visibleInGroup += 1;
        index += 1;
      });
      group.hidden = visibleInGroup === 0;
    });
  }

  function init(root) {
    if (!root || root.dataset.vpInitialized === 'true') return;
    root.dataset.vpInitialized = 'true';

    var slotsContainer = root.querySelector('[data-vp-slots]');
    var empty = root.querySelector('[data-vp-empty]');
    var more = root.querySelector('[data-vp-more]');
    var productInfo = getProductInfo(root);
    var quantityBlock = productInfo ? productInfo.querySelector('.product-form__quantity') : null;
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-vp-slot]'));

    var flexibleSlot = slots.find(function (slot) {
      return String(slot.getAttribute('data-variant-title') || '').trim().toLowerCase() ===
        'zur freien wahl nach absprache mit dem trainer';
    });

    if (flexibleSlot) {
      var flexibleAvailable = flexibleSlot.getAttribute('data-available') === 'true';
      var headerTitle = root.querySelector('.vp-academy-booking__title');
      var headerIntro = root.querySelector('.vp-academy-booking__intro');

      if (headerTitle) headerTitle.textContent = 'Termin nach Absprache';
      if (headerIntro) {
        headerIntro.textContent = 'Deinen Schulungstermin vereinbaren wir individuell mit dir und deinem Trainer.';
      }

      slotsContainer.innerHTML = '';

      if (empty) {
        var emptyTitle = empty.querySelector('strong');
        var emptyText = empty.querySelector('span');

        empty.hidden = false;
        if (emptyTitle) emptyTitle.textContent = 'Freie Terminwahl';
        if (emptyText) {
          emptyText.textContent = 'Nach der Buchung stimmst du deinen Wunschtermin flexibel mit deinem Trainer ab.';
        }
      }

      if (more) more.hidden = true;
      if (quantityBlock) quantityBlock.hidden = true;

      if (flexibleAvailable) {
        setVariant(productInfo, flexibleSlot.getAttribute('data-variant-id'));
      }

      setSubmitState(
        productInfo,
        flexibleAvailable,
        flexibleAvailable ? 'Jetzt buchen' : 'Derzeit nicht verfügbar'
      );
      return;
    }

    var valid = [];

    slots.forEach(function (slot) {
      var info = parseDateRange(slot.getAttribute('data-variant-title'));
      if (!info || info.end.getTime() < today.getTime()) {
        slot.remove();
        return;
      }

      var formatted = formatDate(info);
      var available = slot.getAttribute('data-available') === 'true';
      var inventory = Number(slot.getAttribute('data-inventory') || -1);
      var status = 'Verfügbar';

      if (!available) status = 'Ausgebucht';
      else if (inventory === 1) status = 'Letzter Platz';
      else if (inventory === 2) status = 'Nur noch 2 Plätze';
      else if (inventory > 2) status = inventory + ' Plätze frei';

      slot.querySelector('[data-vp-date-main]').textContent = formatted.main;
      slot.querySelector('[data-vp-date-year]').textContent = formatted.year;
      slot.querySelector('[data-vp-time]').textContent = info.time;
      slot.querySelector('[data-vp-status]').textContent = status;
      slot.disabled = !available;
      slot.classList.toggle('is-sold-out', !available);
      slot._vpDateInfo = info;
      slot._vpMonth = formatted.month;
      valid.push(slot);
    });

    valid.sort(function (a, b) {
      return a._vpDateInfo.start.getTime() - b._vpDateInfo.start.getTime();
    });

    slotsContainer.innerHTML = '';

    if (!valid.length) {
      if (empty) empty.hidden = false;
      if (more) more.hidden = true;
      if (quantityBlock) quantityBlock.hidden = true;
      setSubmitState(productInfo, false, 'Keine Termine verfügbar');
      return;
    }

    if (empty) empty.hidden = true;
    if (quantityBlock) quantityBlock.hidden = false;

    var groups = {};
    valid.forEach(function (slot) {
      var key = slot._vpDateInfo.start.getFullYear() + '-' + String(slot._vpDateInfo.start.getMonth() + 1).padStart(2, '0');
      if (!groups[key]) {
        var group = document.createElement('div');
        group.className = 'vp-academy-month';

        var title = document.createElement('p');
        title.className = 'vp-academy-month__title';
        title.textContent = slot._vpMonth;

        var groupSlots = document.createElement('div');
        groupSlots.className = 'vp-academy-month__slots';

        group.appendChild(title);
        group.appendChild(groupSlots);
        slotsContainer.appendChild(group);
        groups[key] = groupSlots;
      }

      groups[key].appendChild(slot);
      slot.hidden = false;
      slot.addEventListener('click', function () {
        selectSlot(root, slot);
      });
    });

    setSubmitState(productInfo, false, 'Termin auswählen');
    applyLimit(root, false);

    if (valid.length > 4 && more) {
      more.hidden = false;
      more.dataset.expanded = 'false';
      more.addEventListener('click', function () {
        var expanded = more.dataset.expanded === 'true';
        expanded = !expanded;
        more.dataset.expanded = expanded ? 'true' : 'false';
        more.textContent = expanded ? 'Weniger Termine anzeigen' : 'Weitere Termine anzeigen';
        applyLimit(root, expanded);
      });
    } else if (more) {
      more.hidden = true;
    }

    var requestedVariant = null;
    try {
      requestedVariant = new URL(window.location.href).searchParams.get('variant');
    } catch (e) {}

    if (requestedVariant) {
      var requestedSlot = valid.find(function (slot) {
        return slot.getAttribute('data-variant-id') === requestedVariant && !slot.disabled;
      });
      if (requestedSlot) selectSlot(root, requestedSlot);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vp-academy-booking]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();